import React from 'react';
import classes from './TableCheckbox.module.scss';
import MCheckBox from 'views/MCheckBox/MCheckBox';

type Props = {
  className?: string;
  checked?: boolean;
  disabled?: boolean;
  rowCheckbox?: boolean;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
};

const TableCheckboxView: React.FC<Props> = (props: React.PropsWithChildren<Props>) => {
  return (
    <div className={classes['container']}>
      <MCheckBox
        className={props.className}
        rowCheckbox={props.rowCheckbox}
        checked={props.checked}
        disabled={props.disabled}
        onChange={props.onChange}
      ></MCheckBox>
    </div>
  );
};

TableCheckboxView.displayName = 'TableCheckboxView';
TableCheckboxView.defaultProps = {};

export default TableCheckboxView;
